import { Trans } from "react-i18next";

import { Category } from "@api";

export const formatTipName = (category: Category, name: string) => {
  switch (category) {
    case "Total Goals Over/Under":
    case "Home Goals Over/Under":
    case "Away Goals Over/Under":
    case "Away Corners Over/Under":
    case "Home Corners Over/Under":
    case "Total Corners Over/Under":
    case "Away Cards Over/Under":
    case "Home Cards Over/Under":
    case "Total Cards Over/Under":
      return (
        <Trans
          i18nKey={`dynamic-tip.${name.includes("Over") ? "over-goals" : "under-goals"}`}
          values={{ count: name.split(" ")[1] }}
        />
      );
    case "Double Chance":
      return (
        <>
          <Trans i18nKey={name.split("/")[0]} />/
          <Trans i18nKey={name.split("/")[1]} />
        </>
      );
    case "Asian Handicap":
      return (
        <>
          <Trans i18nKey={name.split(" ")[0]} /> {name.split(" ")[1]}
        </>
      );
  }

  return <Trans i18nKey={name} />;
};
